import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { FormattedMessage } from "react-intl";
import { useState } from "react";

import { RoleConfigurationModal } from "../role-configuration-modal";

export const NewRoleButton = () => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<RoleConfigurationModal open={open} onClose={() => setOpen(false)} />
			<Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
				<FormattedMessage id="New Role" defaultMessage="New Role" />
			</Button>
		</>
	);
};
